import { db, trackedZones } from "./index";
import type { Transition } from "./engine";

export interface ChangeGroup {
  at: number;
  delta: number; // seconds clocks move (after - before)
  zones: { id: string; tr: Transition }[];
}

const HORIZON = 400 * 86400;

/** Upcoming (dir=1) or recent (dir=-1) clock changes across all zones, grouped by instant. */
export function collectChanges(instant: number, dir: 1 | -1, extra: string[], limit = 10): ChangeGroup[] {
  const groups = new Map<string, ChangeGroup>();
  for (const id of trackedZones(extra)) {
    const z = db.zone(id);
    const list = dir > 0 ? z.transitionsBetween(instant + 1, instant + HORIZON) : z.transitionsBetween(instant - HORIZON, instant + 1).reverse();
    for (const tr of list.slice(0, 3)) {
      const delta = tr.after.utoff - tr.before.utoff;
      const key = `${tr.at}:${delta}`;
      let g = groups.get(key);
      if (!g) {
        g = { at: tr.at, delta, zones: [] };
        groups.set(key, g);
      }
      g.zones.push({ id, tr });
    }
  }
  const out = [...groups.values()].sort((a, b) => (dir > 0 ? a.at - b.at : b.at - a.at));
  return out.slice(0, limit);
}
